<template>
  <Adminlte>
    <div class="box box-primary center-block">
      <div class="box-header with-border">
        <i class="fa fa-bar-chart font-dark"></i><h3 class="box-title">Relatórios - Segmentados - Textuais</h3>
      </div>
      <section v-if="!isRenderingReports" class="content">
        <button @click="renderReports()" type="button" class="btn btn-primary top-btn">Gerar</button>
        <div class="row main-row">
          <div class="col-xs-12 col-md-9 col-lg-9">
            <div class="report-row">
              <button @click="selectAll()" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
              <button @click="clearSelected()" type="button" class="btn btn-default btn-xs">Limpar</button>
              <div v-for="report in reports" :key="report.id" class="checkbox">
                <label>
                  <input v-model="report.isSelected" type="checkbox"> {{ report.title }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-xs-12 col-md-2">
            <div class="report-row">
                <p><strong>Ano</strong></p>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="year" class="form-control">
                      <option v-for="year in getAvailableYears" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="isRenderingReports" class="content">
        <button @click="isRenderingReports = false" type="button" class="btn btn-primary top-btn">Voltar</button>
        <div class="row text-center display-flex">
          <div v-for="report in selectedReports" :key="report.id" class="col-xs-12 col-lg-6">
            <component :is="getReportComponent(report)" :data="report.data"></component>
          </div>
        </div>
      </section>
    </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ReportClient from '@/services/resource_client/report'
  import ReportFormatter from '@/services/report_formatter'
  import TableReport from '../../components/elements/TableReport'
  import ListReport from '../../components/elements/ListReport'

  export default {
    name: 'SegmentedTextualReports',
    components: { Adminlte, TableReport },
    data () {
      return {
        isRenderingReports: false,
        currentYear: new Date().getFullYear(),
        firstAvailableYear: 1985,
        year: new Date().getFullYear(),
        componentsPerType: {
          'table': TableReport,
          'list': ListReport
        },
        reports: [
          { id: 1, title: 'Principais focos de atuação dos parques tecnológicos', uri: 'reports/park-focus-action-in-year', data: {}, type: 'table', isSelected: false },
          { id: 2, title: 'Principais áreas de atuação das empresas', uri: 'reports/company-areas-expertise-in-year', data: {}, type: 'table', isSelected: false },
          { id: 3, title: 'Valor de investimentos do parque tecnológico', uri: 'reports/park-investments-in-year', data: {}, type: 'table', isSelected: false },
          { id: 4, title: 'Origem dos recursos captados para o parque tecnológico, de acordo com a fonte', uri: 'reports/funds-raised-source-in-year', data: {}, type: 'table', isSelected: false },
          { id: 5, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico', uri: 'reports/resources-obtained-in-year', data: {}, type: 'table', isSelected: false },
          { id: 6, title: 'O parque tecnológico possui', uri: 'reports/park-has-in-year', data: {}, type: 'table', isSelected: false },
          { id: 7, title: 'Porcentagem de parques tecnológicos que oferecem local próprio para instalação de empresas', uri: 'reports/offers-installation-place-in-year', data: {}, type: 'table', isSelected: false },
          { id: 8, title: 'Em relação às modalidades para instalação de empresas residentes, o parque tecnológico, possui', uri: 'reports/installation-place-model-in-year', data: {}, type: 'table', isSelected: false },
          { id: 9, title: 'De quem é a propriedade do terreno do parque', uri: 'reports/park-land-ownership-in-year', data: {}, type: 'table', isSelected: false },
          { id: 10, title: 'Local onde o parque tecnológico se encontra instalado', uri: 'reports/park-installation-location-in-year', data: {}, type: 'table', isSelected: false },
          { id: 11, title: 'Áreas do parque tecnológico (m²) - Terreno e lotes', uri: 'reports/park-land-areas-in-year', data: {}, type: 'table', isSelected: false },
          { id: 12, title: 'Áreas do parque tecnológico (m²) - Prédios e edificações', uri: 'reports/park-edification-areas-in-year', data: {}, type: 'table', isSelected: false },
          { id: 13, title: 'Relação de parques em operação', uri: 'reports/list-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 14, title: 'Relação de parques em implantação', uri: 'reports/list-parks-in-implantation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 15, title: 'Relação de parques em planejamento', uri: 'reports/list-parks-in-planning-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 16, title: 'Número de empresas por parque tecnológico em operação', uri: 'reports/companies-in-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 17, title: 'Relação dos parques em operação por natureza jurídica', uri: 'reports/parks-in-operation-stage-by-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 18, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora administrativa"', uri: 'reports/parks-in-operation-stage-by-administrative-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 19, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora financeira"', uri: 'reports/parks-in-operation-stage-by-finance-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 20, title: 'Relação dos parques em operação que têm incubadora', uri: 'reports/parks-in-operation-stage-having-incubator-in-year', data: {}, type: 'table', isSelected: false },
          { id: 21, title: 'Relação dos parques em operação que têm aceleradora', uri: 'reports/parks-in-operation-stage-having-accelerator-in-year', data: {}, type: 'table', isSelected: false },
          { id: 22, title: 'Relação dos parques em operação que têm relação formal com instituição de ensino superior', uri: 'reports/parks-in-operation-stage-having-higher-education-link-in-year', data: {}, type: 'table', isSelected: false },
          { id: 23, title: 'Relação dos parques em operação que têm relação formal com institutos de pesquisa', uri: 'reports/parks-in-operation-stage-having-research-center-link-in-year', data: {}, type: 'table', isSelected: false },
          { id: 24, title: 'Relação dos parques tecnológicos por focos de atuação', uri: 'reports/parks-by-focus-action-in-year', data: {}, type: 'table', isSelected: false },
          { id: 25, title: 'Relação dos parques tecnológicos que possuem planejamento estratégico', uri: 'reports/parks-having-strategic-planning-in-year', data: {}, type: 'list', isSelected: false },
          { id: 26, title: 'Relação dos parques que estão formalmente associados à instituições', uri: 'reports/parks-which-are-related-to-institutions-in-year', data: {}, type: 'list', isSelected: false },
          { id: 27, title: 'Relação dos parques que possuem certificações', uri: 'reports/parks-which-has-certifications-in-year', data: {}, type: 'list', isSelected: false },
          { id: 28, title: 'Relação dos parques tecnológicos que possuem interação com algum programa de incubação e/ou aceleração', uri: 'reports/parks-having-incubation-acceleration-interaction-in-year', data: {}, type: 'list', isSelected: false },
          { id: 29, title: 'Relação de parques que oferecem incentivos fiscais, creditícios e/ou benefícos às empresas', uri: 'reports/parks-by-incentives-offered-in-year', data: {}, type: 'list', isSelected: false },
          { id: 30, title: 'Relação de empresas âncoras por área de atuação', uri: 'reports/anchor-companies-by-area-in-year', data: {}, type: 'table', isSelected: false },
          { id: 31, title: 'Necessidades futuras para investimentos do parque tecnológico', uri: 'reports/parks-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 32, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Planejamento', uri: 'reports/parks-in-planning-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 33, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Implantação', uri: 'reports/parks-in-implantation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 34, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Operação', uri: 'reports/parks-in-operation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false }
        ]
      }
    },
    methods: {
      renderReports () {
        this.isRenderingReports = true
        this.selectedReports.forEach(r => this.renderReport(r.id))
      },
      renderReport (id) {
        let report = this.reports.find(r => r.id === id)
        ReportClient.getInYear(report.uri, this.year)
          .then(response => {
            report.data = ReportFormatter.textual(response.data, report.title)
            report.isSelected = true
          })
      },
      selectAll () {
        this.reports.forEach(function (r) {
          r.isSelected = true
        })
      },
      clearSelected () {
        this.reports.forEach(function (r) {
          r.isSelected = false
        })
      },
      getReportComponent (r) {
        return this.componentsPerType[r.type]
      }
    },
    computed: {
      getAvailableYears () {
        let years = []
        for (let i = this.currentYear; i >= this.firstAvailableYear; i--) {
          years.push(i)
        }
        return years
      },
      selectedReports () {
        return this.reports.filter(r => r.isSelected)
      }
    }
  }
</script>

<style scoped>
  .main-row {
    color: white;
  }
  .year-label {
    display: table-cell;
    vertical-align: middle;
    height: 34px;
  }
  .center-inside-col {
    display: table;
    margin: 0 auto;
    font-size: small;
  }
  .report-row {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 5px;
  }
  .top-btn {
    margin-bottom: 10px;
  }
  .display-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .display-flex > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// SegmentedTextualReports.vue?7610f9d1